module.exports = __webpack_public_path__ + "img/choose-up-dejun-disabled.1844be35.png";